export const PLAN_TOPICS = ["/plan_smoothed", "/plan"];
export const PLAN_TOPIC = PLAN_TOPICS[0];

export const NAVIGATE_TO_POSE_ACTION = "/navigate_to_pose";
export const NAVIGATE_TO_POSE_STATUS_TOPIC = `${NAVIGATE_TO_POSE_ACTION}/_action/status`;
